import { MIME_TYPES } from "@mantine/dropzone";
import * as pdfjs from "pdfjs-dist";

pdfjs.GlobalWorkerOptions.workerPort = new Worker(
  new URL("pdfjs-dist/build/pdf.worker.mjs", import.meta.url),
  { type: "module" },
);

export const convertPdfPagesToImages = async (file: File): Promise<File[]> => {
  const pdf = await pdfjs.getDocument(URL.createObjectURL(file)).promise;
  const pdfPages = await Promise.all(
    Array.from({ length: pdf.numPages }).map((_, pageIndex) =>
      pdf.getPage(pageIndex + 1),
    ),
  );
  const pdfFileName = file.name.substring(0, file.name.lastIndexOf("."));

  return Promise.all(
    pdfPages.map(async (page) => {
      const viewport = page.getViewport({ scale: 1.5 });
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");

      if (!context) {
        throw new Error("Failed to create canvas context");
      }

      canvas.width = viewport.width;
      canvas.height = viewport.height;

      await page.render({ canvasContext: context, viewport }).promise;

      const pageImageBlob = await new Promise<Blob>((resolve, reject) => {
        canvas.toBlob((blob) => {
          if (!blob) {
            reject(new Error("Failed to create blob from canvas"));
          } else {
            resolve(blob);
          }
        }, MIME_TYPES.png);
      });

      const pdfPageImageFileName = `${pdfFileName}-page-${page.pageNumber}.png`;
      const pdfPageImageFile = new File([pageImageBlob], pdfPageImageFileName, {
        type: MIME_TYPES.png,
      });

      return pdfPageImageFile;
    }),
  );
};

export const getFileUrlsForFile = async (file: File): Promise<string[]> => {
  if (file.type !== MIME_TYPES.pdf) {
    return [URL.createObjectURL(file)];
  }

  const imageFilesForPdfPages = await convertPdfPagesToImages(file);

  return imageFilesForPdfPages.map(URL.createObjectURL);
};
